/**
 * Invoice Status Display Mapping
 * Single source of truth for converting Xero status codes to user-friendly labels and CSS classes
 */

export interface StatusDisplay {
  label: string;
  cssClass: string;
}

const STATUS_MAP: Record<string, StatusDisplay> = {
  DRAFT: { label: 'Draft', cssClass: 'invoice-modal__status--draft' },
  SUBMITTED: { label: 'Sent', cssClass: 'invoice-modal__status--submitted' },
  AUTHORISED: { label: 'Awaiting Payment', cssClass: 'invoice-modal__status--authorised' },
  PAID: { label: 'Paid', cssClass: 'invoice-modal__status--paid' },
  VOIDED: { label: 'Voided', cssClass: 'invoice-modal__status--voided' },
  DELETED: { label: 'Deleted', cssClass: 'invoice-modal__status--voided' },
};

/**
 * Get friendly display label and CSS class for a Xero invoice status
 */
export function getStatusDisplay(status: string): StatusDisplay {
  return STATUS_MAP[status] ?? { label: status, cssClass: '' };
}
